<template>
  <v-app>
    <v-container fluid class="mt-3">
      <v-row class="ml-1 mr-1" justify="center">
        <v-col class="pb-2 pl-2 pr-1" cols="12" lg="10" md="10" sm="12" >
          <v-card class="ma-1 pa">
              <v-card-text>
                <div :style="style">
                  <iframe :src="url" frameborder="0" width="100%" height="1110" style="align-content: center;"></iframe>
                </div>
              </v-card-text>
            </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>


<script>
import {mapActions} from "vuex";

export default {
  name: 'PrintPayStatement',
  props: {
    id: String
  },
  data() {
    return {
      window_width: window.innerWidth,
      url: null,
      style: '',
    };
  },
  // watch: {
  //   "window_width" : function(value0, value1) {
  //   }
  // },
  methods: {
    ...mapActions("ViewApi", ["getFileDownload"]),
    onResize() {
      this.window_width = window.innerWidth;
      this.scalewindow();
    },
    scalewindow(){
      if(this.window_width<900)this.style = `width: ${this.window_width-180}; height: auto; overflow-x: hidden; zoom: ${this.window_width/900}; text-align: center; background-color: white;`;
      else this.style = "width: 100%; height: auto; overflow-x: hidden; zoom: 1.0; background-color: white;"
    }
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  mounted(){
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  async created() {

    if(this.id) this.url = 'https://tradexc.com/#/print/paystatement/' + this.id;
    this.scalewindow();
  },
}

</script>

<style src="./View.scss" lang="scss"/>
